import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=e04d3988&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e04d3988')) {
      api.createRecord('e04d3988', component.options)
    } else {
      api.reload('e04d3988', component.options)
    }
    module.hot.accept("./ItemList.vue?vue&type=template&id=e04d3988&", function () {
      api.rerender('e04d3988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ItemList.vue"
export default component.exports